import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-enterprise';
import {AlertService} from '../../services/alert/alert.service';
import {LoadingService} from '../../services/loading/loading.service';
import {ActivatedRoute} from '@angular/router';
import {BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-view-interstate-scope',
    templateUrl: './view-interstate-scope.component.html',
    styleUrls: ['./view-interstate-scope.component.css'],
    standalone: false
})
export class ViewInterstateScopeComponent implements OnInit {
  orgId: any;
  orgUpdateForm: FormGroup;
  additionalMessageResponse: any;
  redirectedFromBol: any;
  profileName: any;
  currentMessage: any;
  messageArray = [];
  messages: any;
  optionsData: any;
  columnDefs: (ColDef | ColGroupDef)[];
  updateMessagesOptions: GridOptions = this.initializeGridOptions();
  rowData: any;
  public overlayNoRowsTemplate;
  private gridApi;

  constructor(private formBuilder: FormBuilder,
              private alertService: AlertService,
              private tmssLoader: LoadingService,
              private route: ActivatedRoute,
              private bsModalRef: BsModalRef,
              public options: ModalOptions,
  ) {
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No rows to display, please adjust your filters</span>';
    this.orgUpdateForm = this.formBuilder.group({
      newMessage: new FormControl('')
    });
  }

  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        flex: 1,
        wrapText: true,
        autoHeight: true,
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      pagination: true,
      paginationPageSize: 10,
      cacheBlockSize: 10,
      rowData: this.optionsData,
      overlayLoadingTemplate: '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
    };
  }

  /**
   * initializing the ag-grid
   */
  onGridReady(params: any) {
    // params.api.sizeColumnsToFit();
    this.gridApi = params.api;
    // this.gridApi.setHeaderHeight(30);
    this.gridApi.setGridOption('headerHeight', 30);
  }


  ngOnInit() {
    this.optionsData = this.options.initialState;
    this.rowData = this.optionsData.scopeList;
    this.updateColumnDefs();
    this.profileName = this.optionsData.profile;
    this.tmssLoader.hide();
  }


  updateColumnDefs() {
    this.columnDefs = this.getUpdateMessagesOptionsColumnDefs();
  }

  getUpdateMessagesOptionsColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          flex: 1,
          resizable: true,
          wrapText: true,
          autoHeight: true,
          headerName: 'SCAC',
          field: 'scac',
          filter: 'agTextColumnFilter',
          sortable: true

        },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Origin',
        field: 'serviceAreaOriginName',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Destination',
        field: 'serviceAreaDestinationName',
        filter: 'agTextColumnFilter',
        sortable: true
      },
      {
        flex: 1,
        resizable: true,
        wrapText: true,
        headerName: 'Scope Type',
        field: 'scopeType',
        filter: 'agTextColumnFilter',
        sortable: true
      }
    ];
  }

  loadMessageHistory(existingMessages) {
    /* for(let i = 0; i<existingMessages.length(); i++) {
      this.messageHistoryArray[i] = existingMessages[i].message;
    } */
  }

  /**
   * @description cancel message entered
   */
  cancelMessage() {
    // this.bsModalRef.hide();
  }

  closeModal() {
    this.bsModalRef.hide();

  }

}
